export class Combinator {
    skip(rhs) {
        return new Skip(this, rhs);
    }
    then(rhs) {
        return new Then(this, rhs);
    }
    many(min = 0) {
        return new Many(this, min);
    }
    map(f) {
        return new MapCombinator(this, f);
    }
    parse(items) {
        let r = this.next(items, 0);
        if (r == null || r.index != items.length)
            return null;
        return r.data;
    }
}
export function S(s) {
    return new StringCombinator(s);
}
export function Re(s) {
    return new RegexCombinator(s);
}
export function Any() {
    return new AnyCombinator();
}
export function seq(xs) {
    return new SeqCombinator(xs);
}
export function dict(xs) {
    return new DictCombinator(xs);
}
export function union(xs) {
    return new UnionCombinator(xs);
}
class SeqCombinator extends Combinator {
    constructor(inner) {
        super();
        this.inner = inner;
    }
    next(items, index) {
        let data = [];
        for (let i = 0; i < this.inner.length; i++) {
            let r = this.inner[i].next(items, index);
            console.log("Union index " + i + ": ", r);
            if (r === null)
                return null;
            data.push(r.data);
            index = r.index;
        }
        return {
            data: data,
            index
        };
    }
}
class DictCombinator extends Combinator {
    constructor(inner) {
        super();
        this.inner = inner;
    }
    next(items, index) {
        let data = {};
        for (let k in this.inner) {
            let r = this.inner[k].next(items, index);
            if (r === null)
                return null;
            if (!k.startsWith("_")) {
                data[k] = r.data;
            }
            index = r.index;
        }
        return {
            data: data,
            index
        };
    }
}
class UnionCombinator extends Combinator {
    constructor(inner) {
        super();
        this.inner = inner;
    }
    next(items, index) {
        for (let i = 0; i < this.inner.length; i++) {
            const r = this.inner[i].next(items, index);
            if (r !== null)
                return r;
        }
        return null;
    }
}
class MapCombinator extends Combinator {
    constructor(inner, f) {
        super();
        this.inner = inner;
        this.f = f;
    }
    next(items, index) {
        let r = this.inner.next(items, index);
        if (r == null)
            return r;
        return { data: this.f(r.data), index: r.index };
    }
}
class RegexCombinator extends Combinator {
    constructor(s) {
        super();
        this.s = new RegExp("^" + s + "$").compile();
    }
    next(items, index) {
        if (index >= items.length)
            return null;
        let m = items[index].match(this.s);
        if (m === null)
            return null;
        return { data: items[index], index: index + 1 };
    }
}
class StringCombinator extends Combinator {
    constructor(s) {
        super();
        this.s = s;
    }
    next(items, index) {
        if (index >= items.length || items[index] !== this.s)
            return null;
        return { data: this.s, index: index + 1 };
    }
}
class AnyCombinator extends Combinator {
    constructor() {
        super();
    }
    next(items, index) {
        if (index >= items.length)
            return null;
        return { data: items[index], index: index + 1 };
    }
}
class Skip extends Combinator {
    constructor(lhs, rhs) {
        super();
        this.lhs = lhs;
        this.rhs = rhs;
    }
    next(items, index) {
        const res1 = this.lhs.next(items, index);
        if (res1 == null)
            return null;
        const res2 = this.rhs.next(items, res1.index);
        if (res2 == null)
            return null;
        return { data: res1.data, index: res2.index };
    }
}
class Then extends Combinator {
    constructor(lhs, rhs) {
        super();
        this.lhs = lhs;
        this.rhs = rhs;
    }
    next(items, index) {
        const res1 = this.lhs.next(items, index);
        if (res1 == null)
            return null;
        const res2 = this.rhs.next(items, res1.index);
        if (res2 == null)
            return null;
        return res2;
    }
}
class Many extends Combinator {
    constructor(inner, min) {
        super();
        this.inner = inner;
        this.min = min;
    }
    next(items, index) {
        let res = [];
        while (true) {
            let r = this.inner.next(items, index);
            if (r == null)
                break;
            res.push(r.data);
            index = r.index;
        }
        if (res.length < this.min)
            return null;
        return {
            data: res,
            index
        };
    }
}
